<template>
  <div v-if="currentSequence">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <div class="box-outlined mb-8">
      <v-layout
        d-flex
        row
        ma-0
        align-center
        justify-space-between
        class="box-header"
      >
        <!-- <v-flex xs12>
          <h2 class="box-header-item mb-3 mb-md-0" v-html="currentSequence.info[`title_${$i18n.locale}`]"></h2>
        </v-flex> -->
        <v-flex xs12 sm7 lg8>
          <h2
            class="box-header-item mb-3 mb-sm-0"
            v-html="currentSequence.info[`title_${$i18n.locale}`]"
          ></h2>
        </v-flex>
        <v-divider vertical inset></v-divider>
        <v-flex xs12 sm3 lg2>
          <p class="box-header-item ma-0 text-center d-flex align-center">
            <span class="h2 mr-1" v-html="currentSequence.total.point"></span>
            <strong>({{ $t("survey-sequence-block.point") }})</strong>
          </p>
        </v-flex>
      </v-layout>

      <v-layout
        d-block
        d-md-flex
        row
        ma-0
        align-center
        justify-space-between
        class="box-content"
      >
        <v-layout
          d-block
          d-md-flex
          row
          ma-0
          mb-5
          align-center
          justify-space-between
          class="instruction"
        >

          <v-flex xs12 md6>
            <small>{{ $tc("survey-sequence-block.score-1", 1,
                   {question: currentSequence ? currentSequence.total.question : '0',
                    score: currentSequence ? currentSequence.total.point : '0'}) }}</small><br>
            <small>{{ $tc("survey-sequence-block.score-2", 1,
                   {question: currentSequence ? currentSequence.done.question : '0',
                    score: currentSequence ? currentSequence.done.point : '0'}) }}</small><br>
            <small>{{ $tc("survey-sequence-block.score-3", 1,
                   {answermandatoryq: currentSequence ? currentSequence.done.mandatoryq : '0',
                    mandatoryq: currentSequence ? currentSequence.total.mandatoryq : '0'}) }}</small>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12 md5>
            <h4>{{ $t("survey-sequence-block.progress-bar-title") }}</h4>
            <ProgressBar
              :progress="parseInt(currentSequence.done.point)"
              :objectif="parseInt(currentSequence.total.point)"
              :minimum="parseInt(currentSequence.total.requiredpt)"
            ></ProgressBar>
          </v-flex>
        </v-layout>

        <!-- Sequence image -->
        <v-flex xs12>
          <v-img
            v-if="img && img !== ''"
            :src="img"
            aspect-ratio="1.7778"
            class="mb-5"
          ></v-img>
        </v-flex>

        <v-flex xs12 pa-1>
          <pre><p v-html="currentSequence.info[`text_${$i18n.locale}`]"
          ></p></pre>
        </v-flex>
      </v-layout>
    </div>

    <!-- Navigation buttons -->
    <div class="overflow-hidden mb-8" v-if="!noButton">
      <!-- <v-btn
        outlined
        rounded
        color="primary"
        @click="createTask()"
        class="float-left"
      >
        create task
      </v-btn> -->

      <template v-if="currentSequence">
        <DelegateTaskDial
          :answerid="answerid"
          :sequenceid="sequence.id"
          :infoDelegation='currentSequence.info'
          :status="status"
          @reloadSequence="getSequence"
        ></DelegateTaskDial>
      </template>

      <v-btn
        v-if="currentSequence.questions.length >= 1 && !onlyTask"
        outlined
        rounded
        color="primary"
        class="float-right"
        @click="changeTabVal({type: 'question', object: currentSequence.questions[0]})"
      >
        {{ $t("survey-sequence-block.btn-1") }}
      </v-btn>
    </div>

    <!-- if need to show question -->
    <template v-if="showQuestion">
      <div v-for="question in currentSequence.questions" :key="question.id">
        <QuestionBox
          :question="question"
          :answerid="answerid"
          :maxDerogations="maxDerogations"
          :doneDerogations="doneDerogations"
          @updateSeq="updateSequence"
          @updateSubmitBtn="refreshSubmitBtn"
          :disabledInputs="status === 'sent' || status === 'verify' || status === 'success' || status === 'failed' ? true : false"
          noButton
          :inspector="inspector ? true : false"
          class="mb-5"
        ></QuestionBox>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { showSequence } from '@/js/survey/showSequence'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import { decode64 } from '@/js/utils/base64'
// import { getAttach } from '@/js/utils/getAttach'
import ProgressBar from '@/components/progress/ProgressBar'
import QuestionBox from '@/components/audits/survey/QuestionBox'
import DelegateTaskDial from '@/components/audits/delegate/DelegateTaskDial'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    sequence: Object,
    answerid: String,
    maxDerogations: Number,
    doneDerogations: Number,
    noButton: Boolean,
    onlyTask: Boolean,
    showQuestion: {
      type: Boolean,
      default: () => false
    },
    status: String,
    keywords: String,
    inspector: {
      type: Boolean,
      default: () => false
    }
  },

  components: {
    ProgressBar,
    QuestionBox,
    DelegateTaskDial,
    HTTPresponse
  },

  data () {
    return {
      currentSequence: null,
      img: '',
      httpalert: false
    }
  },

  async created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    // this.$root.disableInterceptor()
    this.getSequence()
    // const params = {
    //   answerid: this.answerid,
    //   path: this.sequence.path,
    //   sequenceid: this.sequence.id,
    //   key: this.$store.state.auth.token
    // }
    // await showSequence(params)
    //   .then(response => {
    //     this.currentSequence = response
    //     if (response.info.illustration) {
    //       let illu = response.info.illustration
    //       if (illu.includes('bin/')) illu = process.env.VUE_APP_API_ENDPOINT + illu.replace('bin/', '')
    //       this.img = illu
    //     }
    //     // this.$root.enableInterceptor()
    //     this.$root.$on('enableInterceptor')
    //   })
    //   .catch(() => {
    //     this.httpalert = true
    //     setTimeout(() => {
    //       this.httpalert = false
    //     }, 4000)
    //     this.$root.$on('enableInterceptor')
    //     // this.$root.enableInterceptor()
    //   })
  },

  mounted () {
    this.$root.$on('disableInterceptor')
  },

  methods: {
    getSequence() {
      const params = {
        answerid: this.answerid,
        path: this.inspector && this.$route.params.sequenceid ?
              this.$route.params.sequenceid : this.sequence.path,
        sequenceid: this.sequence.id,
        key: this.inspector && this.$route.params.validkey ?
             this.$route.params.validkey : this.$store.state.auth.token
      }
      showSequence(params)
        .then(response => {
          this.currentSequence = response
          if (response.info.illustration) {
            let illu = response.info.illustration
            if (illu.includes('bin/')) illu = randomBaseUrl(0, 3) + illu.replace('bin/', '')
            this.img = illu
          }
          // this.$root.enableInterceptor()
          this.$root.$on('enableInterceptor')
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
          this.$root.$on('enableInterceptor')
          // this.$root.enableInterceptor()
        })
    },

    async refreshSubmitBtn () {
      await this.$emit('updateSubmitBtn')
      this.getSequence()
    },

    updateSequence () { this.$emit('updateAllSeq') },

    changeTabVal (value) {
      this.$emit('tabChnage', value)
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
